import React, { useState } from "react";
import { noop } from "utils/General";
import Header from "Portal/NewPortal/HeaderBar/MobileMenuFlyOver/View/Header";
import Body from "./body";
import SwitchPortals from "./SwitchPortals";
const MobileSwitchPortal = ({ handleClose = noop }) => {
  const [openSwitchPortals, setOpenSwitchPortals] = useState(false);
  return (
    <div>
      <Header hideModal={handleClose} name="Actions" xSize={16} height={56} />
      {!openSwitchPortals && (
        <Body
          handleClose={handleClose}
          setOpenSwitchPortals={setOpenSwitchPortals}
        />
      )}
      {openSwitchPortals && (
        <SwitchPortals
          handleClose={handleClose}
          setOpenSwitchPortals={setOpenSwitchPortals}
        />
      )}
    </div>
  );
};

export default MobileSwitchPortal;
